import SelectedWarehouseMarker from 'containers/Playground/Objects/Warehouses/SelectedWarehouseMarker'
import usePlaceMapParams from './hooks/usePlaceMapParams'
import Legend from 'containers/Playground/Legend'
import Playground from 'containers/Playground'
import React from 'react'

const playground = <Playground />
const legend = <Legend />

interface MapProps {
  header: React.JSX.Element
}

const Map: React.FC<MapProps> = ({ header }) => {
  const { id } = usePlaceMapParams()

  return (
    <div className='placeMap__playground'>
      {header}
      {playground}
      {legend}
      <SelectedWarehouseMarker typeId={id} />
    </div>
  )
}

export default Map
